import React from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { SWEEPSTAKES_MOCK_DATA } from '../../../../../core/Data/SweepstakesMockData';
import { SWEEPSTAKES_CONSTANTS } from '../../../../../core/Constants';
import { mapSweepstakesData } from '../../../utils/SweepstakesDataMapper';
import { gotoLogonModule, handleSignOutSignIn } from '../../../../../common/utils/AccountUtils';

export const UnauthenticatedContent = ({ isPurchaser }) => {
  const data = mapSweepstakesData(
    isPurchaser
      ? SWEEPSTAKES_MOCK_DATA.purchaser
      : SWEEPSTAKES_MOCK_DATA.unauthenticated);
  const handleAuthClick = isPurchaser ? handleSignOutSignIn : gotoLogonModule;

  const content = (
    <div>
      <Typography variant="body-base" data-testid="unauthenticated-description">
        {data.drawerDescription}
      </Typography>
    </div>
  );

  const footer = (
    <Button
      variant="primary"
      fullWidth
      onClick={handleAuthClick}
      data-testid="unauthenticated-sign-in-button"
    >
      {SWEEPSTAKES_CONSTANTS.AUTH_CTA_TEXT(isPurchaser)}
    </Button>
  );

  return { content, footer };
};
